/* tslint:disable */
/* eslint-disable */
export enum PaymentStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID',
  Partiallypaid = 'PARTIALLYPAID',
}
